import { useCallback } from 'react';

import { useCriteriaRequirementsState } from '../criteria/useCriteriaRequirementsState';
import { createBlankRequirement } from '../../utils';
import { EditableRequirement } from '../../types';
import { useQueryStateContext } from '../../contexts';

export const useAddRequirement = () => {
  const { setRequirements } = useCriteriaRequirementsState();
  const { setToLatestId } = useQueryStateContext();
  return useCallback(
    (reqOpt: EditableRequirement = createBlankRequirement()) => {
      setRequirements((requirements) => [...requirements, reqOpt]);
      setToLatestId(reqOpt.id);
    },
    [setRequirements],
  );
};
